module.exports = __webpack_public_path__ + "img/conception.b895f11a.jpg";